var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.636,
    height: 11.636,
    viewBox: "0 0 11.636 11.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-175 -285.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_FILL1_wght400_GRAD0_opsz48_2_",
    "data-name": "add_FILL1_wght400_GRAD0_opsz48 (2)",
    d: "M15.195,21.636V16.441H10V15.195h5.195V10h1.247v5.195h5.195v1.247H16.441v5.195Z",
    transform: "translate(165 275.138)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.44e3a312104a1f99ad8ef2825a16a602.svg";
export { ForwardRef as ReactComponent };